import { Table, TableContainer, TablePagination } from '@material-ui/core';
import { PaymentPlan } from '@nemuru-eng/js-api-client';
import React, { useState } from 'react';

import { SliderWarning } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/SliderWarning';
import { PaymentPlanTableBody } from '@/components/modules/PaymentPlan/components/PaymentPlanTableSection/components/PaymentPlanTable/components/PaymentPlanTableBody';
import { usePaymentPlanTable } from '@/components/modules/PaymentPlan/components/PaymentPlanTableSection/components/PaymentPlanTable/hooks/usePaymentPlanTable';
import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';
import { Text } from '@/components/shared/components/Text';

const tableElementId = 'payment-plan-table-container';

interface PaymentPlanTableProps {
  paymentPlan: PaymentPlan;
  editModeAllowed?: boolean;
  defaultRowsPerPage?: number;
}

export const PaymentPlanTable = ({
  paymentPlan,
  editModeAllowed = false,
  defaultRowsPerPage = 12,
}: PaymentPlanTableProps) => {
  const { classes, stickyCellStyle, isScrollable } = useDefaultTable({
    tableElementId,
  });
  const { columns } = usePaymentPlanTable();

  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [page, setPage] = useState(0);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  return (
    <>
      <TableContainer id={tableElementId}>
        <Table>
          <CustomHeader
            tableProps={{ classes, stickyCellStyle: { ...stickyCellStyle, minWidth: '20px', maxWidth: '20px' } }}
            columns={columns}
          />
          <PaymentPlanTableBody
            paymentPlan={paymentPlan}
            editModeAllowed={editModeAllowed}
            tableProps={{ classes, stickyCellStyle }}
            paginationProps={{ rowsPerPage, page }}
          />
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 12, 25]}
        component="div"
        count={paymentPlan.lines.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage={<Text tId={'ROWS_PER_PAGE'} />}
      />
      {isScrollable && (
        <>
          <SliderWarning />
        </>
      )}
    </>
  );
};
